import Link from "next/link";
import styled from "styled-components";
import { breakpoints } from "styles";

export const Ticker = styled.div`
  display: inline-flex;
  border-radius: 6px;
  justify-content: center;
  align-items: flex-start;
  gap: 8px;
  background: ${({ theme }) => theme.colors.brand["50"]};
  color: ${({ theme }) => theme.colors.brand["600"]};
  padding: 12px;
  margin-top: 8px;
  margin-bottom: 16px;
`;

export const PageContainer = styled.div`
  @media ${breakpoints.laptop} {
    display: grid;
    grid-template-columns: 382px auto;
  }
`;

export const BannerContainer = styled.div`
  display: none;
  background-color: ${({ theme }) => theme.colors.blue["50"]};
  height: calc(100vh - 129px);
  padding: 48px 32px 0 32px;
  color: ${({ theme }) => theme.colors.neutral["1000"]};
  position: relative;
  @media ${breakpoints.laptop} {
    display: inline;
  }
`;
export const ImageConatainer = styled.div`
  display: flex;
  position: absolute;
  width: 100%;
  height: 425px;
  bottom: 0;
  left: 0;
`;

export const FormWrapper = styled.div`
  width: 100%;
  max-width: 90vw;
  padding: 32px;
  height: calc(100vh - 145px);
  @media ${breakpoints.laptop} {
    max-width: 60vw;
  }
  display: flex;
  flex-direction: column;
  justify-content: space-between;
`;

export const SlotWrapper = styled.div`
  max-height: calc(100vh - 316px);
  overflow-y: auto;
  overflow-x: hidden;
  display: flex;
  gap: 8px;
  flex-direction: column;
`;

export const SlotCardWrapper = styled.div<{
  isSelected: boolean;
  isDisabled: boolean;
}>`
  border: 2px solid
    ${({ isSelected, theme }) =>
      isSelected ? theme.colors.brand["500"] : theme.colors.neutral["200"]};
  border: ${({ isDisabled }) => (isDisabled ? "none" : "")};
  cursor: ${({ isDisabled }) => (isDisabled ? "not-allowed" : "pointer")};
  color: ${({ isDisabled, isSelected, theme }) =>
    isDisabled
      ? theme.colors.neutral["400"]
      : isSelected
        ? theme.colors.brand["500"]
        : theme.colors.brand["1000"]};
  background: ${({ isDisabled, isSelected, theme }) =>
    isDisabled
      ? theme.colors.neutral["100"]
      : isSelected
        ? theme.colors.blue["50"]
        : theme.colors.white};
  border-radius: 6px;
  padding: 12px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  transition: all 0.3s;

  &:hover {
    background: ${({ isDisabled, theme }) =>
      !isDisabled ? theme.colors.blue["50"] : ""};
  }
`;

export const BannerTitle = styled.p`
  margin: 0;
  font-weight: 700;
  font-family: ${({ theme }) => theme.fonts.primary};
  color: ${({ theme }) => theme.colors.neutral["1000"]};
  font-size: ${({ theme }) => theme.fontSizes["3xl"]};
`;

export const BanerSubTitle = styled.p`
  margin: 24px 0 0 0;
  color: ${({ theme }) => theme.colors.neutral["1000"]};
  font-size: ${({ theme }) => theme.fontSizes["xl"]};
`;

export const ChooseSlotTitle = styled.p`
  margin: 0;
  font-weight: 700;
  font-family: ${({ theme }) => theme.fonts.primary};
  color: ${({ theme }) => theme.colors.neutral["1000"]};
  font-size: ${({ theme }) => theme.fontSizes["2xl"]};
`;

export const StepText = styled.p`
  margin: 0;
  font-weight: 700;
  color: ${({ theme }) => theme.colors.white};
  font-size: ${({ theme }) => theme.fontSizes["lg"]};
`;

export const ContinueText = styled.p`
  margin: 0;
  font-weight: 700;
  color: ${({ theme }) => theme.colors.white};
  font-size: ${({ theme }) => theme.fontSizes["xl"]};
`;

export const ArrowRight = styled.div`
  transform: rotate(180deg);
  display: flex;
`;

export const AccordionContentWrapper = styled.div`
  display: flex;
  justify-content: center;
  width: 100%;
  gap: 8px;
  flex-direction: column;
`;

export const SlotContainer = styled.div`
  display: flex;
  justify-content: center;
  width: 100%;
`;

export const ButtonContentWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
`;

export const ContinueTextWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 8px;
`;

export const AccordionTitleContainer = styled.span`
  display: flex;
  align-items: center;
  gap: 8px;
`;
export const AccordionTitle = styled.p`
  margin: 0;
  font-weight: 700;
  font-size: ${({ theme }) => theme.fontSizes["lg"]};
  font-family: ${({ theme }) => theme.fonts.secondary};
  color: ${({ theme }) => theme.colors.neutral["700"]};
`;
export const AccordionSubTitle = styled.span`
  display: flex;
  flex-direction: column;
  gap: 8px;
  margin-top: 8px;
`;

export const SlotDateAndTime = styled.p`
  font-family: ${({ theme }) => theme.fonts.primary};
  font-size: ${({ theme }) => theme.fontSizes.md};
  font-weight: 700;
  margin: 0;
`;

export const Divider = styled.div`
  border-left: 1px solid ${({ theme }) => theme.colors.neutral[100]};
  height: 12px;
  margin: 0 4px;
`;

export const TeacherName = styled.p`
  margin: 0;
  color: ${({ theme }) => theme.colors.neutral[500]};
  font-size: ${({ theme }) => theme.fontSizes.sm};
`;

export const SlotStartDateAndSeatCapacity = styled.span`
  display: flex;
  align-items: center;
  gap: 8px;
`;

export const HeaderWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

export const HelpButtonWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  cursor: pointer;
  &:hover {
    opacity: 0.8;
  }
`;
export const HelpButtonText = styled.p`
  color: ${({ theme }) => theme.colors.brand["600"]};
  font-weight: 700;
  font-family: ${({ theme }) => theme.fonts.primary};
  margin: 0;
`;

export const SkipToJadwalLink = styled(Link)`
  text-decoration: none;
  margin-top: 8px;
  display: block;
`;
